import React from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../layout/breadcrumb";
import DprHeader from "../../layout/dprHeader";
import "./archival.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DprRecord from "./dpr-record/dpr-record";
import ResourceRecord from "./dpr-record/resource-record";
import IssuesRecord from "./dpr-record/issues-record";
import RiskRecord from "./dpr-record/risk-record";
import QualityRecord from "./dpr-record/quality-record";
import SafetyRecord from "./dpr-record/safety.record";
import Picture from "./dpr-record/picture";

export default function Archival() {
  const location = useLocation();
  const data = location.state || {};
  return (
    <React.Fragment>
      <div className="pb-5">
        <Breadcrumbs title="Project Archival" menu="" link="Project Archival" />
        <DprHeader project={data} />

        <div className="card mt-4 card-none-b">
          <div className="card-body">
            <Tabs>
              <div
                className="row"
                id="risk-register"
                style={{ marginLeft: 10, marginRight: 10 }}
              >
                <div className="col-12">
                  <TabList>
                    <Tab>DPR Record</Tab>
                    <Tab>Resource Record</Tab>
                    <Tab>Issue Record</Tab>
                    <Tab>Risk Record</Tab>
                    <Tab>Quality Record</Tab>
                    <Tab>Safety Record</Tab>
                    <Tab>Picture</Tab>
                  </TabList>
                </div>
                <hr />
              </div>
              <div className="row" style={{ marginLeft: 20 }}>
                <TabPanel>
                  <DprRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <ResourceRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <IssuesRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <RiskRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <QualityRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <SafetyRecord project={data} />
                </TabPanel>
                <TabPanel>
                  <Picture project={data} />
                </TabPanel>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
